import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import "moment/locale/es";
import { BoxListCourse } from "./boxListCourse";
import PictureCourse from "../../assets/imgs/picture_course.png";
import "./courseView.scss";
import { courseViewService } from "../../services/courseView.service";
import { useSelector } from "react-redux";

export function CourseView(props) {
  const [dataGrid, setDataGrid] = useState([]);
  const calendarStrings = useSelector((state) => state.calendarStrings);
  const [activeAsideSurvey, setStateAsideSurvey] = useState("");
  const [userProfile, setUserProfile] = useState({});
  const [dataGridCompleted, setDataGridCompleted] = useState([]);

  const AsidePurchaseBox = () => {
    setStateAsideSurvey(activeAsideSurvey === "" ? " is-show" : "");
  };

  async function GetUserProfileCourse() {
    courseViewService.GetUserProfileCourse().then((result) => {
      if (result) {
        setUserProfile(result[0]);
      }
    });
  }

  async function getCourse() {
    courseViewService.getCourse().then((result) => {
      if (result) {
        setDataGrid(result);
      }
    });
  }

  async function getCourseCompleted() {
    courseViewService.getCourseComplete().then((result) => {
      if (result) {
        setDataGridCompleted(result);
      }
    });
  }

  useEffect(() => {
    getCourse();
    GetUserProfileCourse();
    getCourseCompleted();
  }, []);

  function setCompleteCourse(course) {
    if (!course.isCompleted) {
      courseViewService.completeCourse(course.courseId).then((result) => {
        getCourse();
        getCourseCompleted();
        GetUserProfileCourse();
      });
    }
  }

  return (
    <section className="wrapper_surveys wrapper_course padd">
      <div className="content_surveys ">
        <div className="row align-items-center mb-4">
          <div className="col">
            <h2 className="mb-0 text fnt_medium ">Talleres</h2>
          </div>
          <div className="col text-muted box_more_survey">
            <span className="d-none d-sm-block">
              <Moment locale="es" format="DD [de] MMMM  YYYY">
                {Date.now()}
              </Moment>
            </span>
            <span className="btn_ellipsis" onClick={AsidePurchaseBox}>
              <i className="fas fa-ellipsis-v"></i>
            </span>
          </div>
        </div>
        <div className="content_ttls">
          <div className="minw">
            <h4 className="text fnt_medium ttl mb-3 text-white">
              Accede a nuestro contenido multimedia
            </h4>
            <p className="text fnt_medium">Próximos eventos.</p>
          </div>
          <div className="box_img_surveys">
            <img src={PictureCourse} alt="Capacitación" />
          </div>
        </div>

        <BoxListCourse
          dataGrid={dataGrid}
          setCompleteCourse={setCompleteCourse}
        />

        <p className="text-muted mt-4 ">
          Este curso es personal, ingresa a cada link de video y/o material que
          te sea programado.
        </p>
      </div>
      <aside className={`aside_lateral trans ${activeAsideSurvey}`}>
        <span className="btn_ellipsis_close" onClick={AsidePurchaseBox}>
          <i className="far fa-window-close"></i>
        </span>
        <div className="text-center">
          <h3 className="text fnt_medium mb-1">Recompensas</h3>
          <h5 className="text-muted">
            {
              //userProfile && (userProfile.nickname != null || userProfile.nickname !='')
              //? userProfile.nickname
              //    :
              userProfile.middleName +
                " " +
                userProfile.lastName +
                " " +
                userProfile.firstName
            }
          </h5>

          <div className="box_avatar_user">
            <span className="avatar">
              <img
                src={userProfile && userProfile.urlProfileImage}
                alt="NameUser"
              />
            </span>
          </div>
          {dataGrid.length === 0 ? (
            <h6 className="text fnt_medium mb-1">
              Por el momento no tienes cursos pendientes{" "}
            </h6>
          ) : (
            <div>
              <h6 className="text fnt_medium mb-1">{dataGrid[0].data.name} </h6>
              <h6>
                Vence{" "}
                <Moment calendar={calendarStrings}>
                  {dataGrid[0].data.endDate}
                </Moment>
              </h6>
              <h3 className="text fnt_medium c_green">
                {dataGrid[0].data.reward} puntos
              </h3>
            </div>
          )}
        </div>
        <div className="prev_surveys">
          <h6 className="text fnt_medium mb-4 text-muted">Cursos Realizados</h6>
          {dataGridCompleted.length === 0 ? (
            <h6 className="text fnt_medium mb-1">
              {" "}
              Por el momento no tienes cursos realizados
            </h6>
          ) : (
            dataGridCompleted.map((item) => {
              return (
                <div className="item_prev_surveys" key={item.courseId}>
                  <span>
                    <i className="fas fa-check-circle"></i>
                  </span>
                  <div>
                    <h6 className="mb-0 text fnt_medium">{item.name}</h6>
                    <p>
                      <small className="text-muted">
                        <Moment calendar={calendarStrings}>
                          {item.completedDate}
                        </Moment>
                      </small>
                    </p>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </aside>
    </section>
  );
}
